import type { RoleplaySessionFailure } from '@/lib/roleplaySessionGuard.ts';
import { m } from '@/paraglide/messages.js';

/* A failed load, in the three ways it can fail. */
export function practiceFailureMessage(failure: RoleplaySessionFailure): string {
  if (failure === 'missing') {
    return m.practice_session_missing();
  }
  if (failure === 'impersonated') {
    return m.practice_session_impersonated();
  }
  return m.practice_session_failed();
}
